module.exports = __webpack_public_path__ + "front/img/25.10492a30.jpg";